import { useEffect } from 'react';

/**
 * @deprecated FastBooking was replaced by /FindMoorings/Book/:mooring_id.
 * Hard-redirects old /FastBooking/* URLs so direct links always forward.
 */
function FastBookingRedirect({ match, location }) {
  useEffect(() => {
    const mooringId = match.params.mooring_id;
    const search = location.search || '';
    const target = mooringId
      ? `/FindMoorings/Book/${mooringId}${search}`
      : `/FindMoorings${search}`;

    window.location.replace(target);
  }, [location.search, match.params.mooring_id]);

  return null;
}

export default FastBookingRedirect;
